(function () {

    'use strict';

    var lastKeepAlive;

    angular.module('iplusjs.integration', [
        'lodash',
        'moment',
        'modernizr',
        'iplusjs.config',
        'iplusjs.utils.format'
    ])
        .config(config)
        .run(run)
        .provider('IntegrationService', IntegrationServiceProvider);

    run.$inject = [
        '$rootScope',
        '$log',
        '$window',
        'lodash',
        'IntegrationService'
    ];

    function run($rootScope, $log, $window, _, IntegrationService) {
        var appWindow = angular.element($window);

        appWindow.on('click', function () {
            IntegrationService.keepAlive().catch(function (data) {
                data = data || {};

                if (data.active === false || data === 'KEINE_SID') {
                    IntegrationService.setIntegrationParams({
                        externalSid: null
                    });

                    if (!IntegrationService.getIntegrationParams().isTokenLogin) {
                        IntegrationService.createAnonymSession().then(function (sid) {
                            lastKeepAlive = null;
                            IntegrationService.setIntegrationParams({
                                externalSid: sid,
                                externalPermissions: null
                            });

                            $rootScope.$emit('iplusjs:externalSidCreated');
                        }).catch(function (error) {
                            $log.error('IntegrationService.createAnonymSession', error);
                        });
                    }
                }
            });
        });

        $rootScope.$on('iplusjs:heightChanged', function (event) {
            $log.info('IntegrationService iplusjs:heightChanged', event);
            IntegrationService.throttledCheckSize();
        });

        $rootScope.$on('$viewContentLoaded', function (event) {
            $log.info('IntegrationService $viewContentLoaded', event);
            IntegrationService.clearMaxHeight();
            IntegrationService.throttledCheckSize();
        });

        $rootScope.$on('$viewContentAnimationEnded', function (event) {
            $log.info('IntegrationService $viewContentAnimationEnded', event);
            IntegrationService.throttledCheckSize();
        });
    }

    config.$inject = [
        '$provide'
    ];
    function config($provide) {
        $provide.decorator('ngIfDirective', ngIfDirectiveDecorator);
        $provide.decorator('ngShowDirective', ngShowDirectiveDecorator);
        $provide.decorator('ngHideDirective', ngHideDirectiveDecorator);

        ngIfDirectiveDecorator.$inject = [
            '$rootScope',
            '$delegate',
            '$timeout',
            'lodash'
        ];
        ngShowDirectiveDecorator.$inject = [
            '$rootScope',
            '$delegate',
            '$timeout',
            'lodash'
        ];
        ngHideDirectiveDecorator.$inject = [
            '$rootScope',
            '$delegate',
            '$timeout',
            'lodash'
        ];
        function ngIfDirectiveDecorator($rootScope, $delegate, $timeout, _) {
            var directive = $delegate[0],
                linkFn = directive.link;

            directive.compile = function () {
                return function ($scope, $element, $attrs) {
                    linkFn.apply(this, arguments);
                    $scope.$watch($attrs.ngIf, _.debounce(function (newValue, oldValue) {
                        if (angular.isDefined(newValue) && newValue !== null && newValue !== oldValue) {
                            $timeout(function () {
                                $rootScope.$emit('iplusjs:heightChanged');
                            }, 0);
                        }
                    }, 600));
                };
            };

            return $delegate;
        }
        function ngShowDirectiveDecorator($rootScope, $delegate, $timeout, _) {
            var directive = $delegate[0],
                linkFn = directive.link;

            directive.compile = function () {
                return function ($scope, $element, $attrs) {
                    linkFn.apply(this, arguments);
                    $scope.$watch($attrs.ngShow, _.debounce(function (newValue, oldValue) {
                        if (angular.isDefined(newValue) && newValue !== null && newValue !== oldValue) {
                            $timeout(function () {
                                $rootScope.$emit('iplusjs:heightChanged');
                            }, 0);
                        }
                    }, 600));
                };
            };

            return $delegate;
        }
        function ngHideDirectiveDecorator($rootScope, $delegate, $timeout, _) {
            var directive = $delegate[0],
                linkFn = directive.link;

            directive.compile = function () {
                return function ($scope, $element, $attrs) {
                    linkFn.apply(this, arguments);
                    $scope.$watch($attrs.ngHide, _.debounce(function (newValue, oldValue) {
                        if (angular.isDefined(newValue) && newValue !== null && newValue !== oldValue) {
                            $timeout(function () {
                                $rootScope.$emit('iplusjs:heightChanged');
                            }, 0);
                        }
                    }, 600));
                };
            };

            return $delegate;
        }
    }

    IntegrationServiceProvider.$inject = [];
    function IntegrationServiceProvider() {
        var that = this,
            mappings = {},
            storeName = null,
            allowedMessageEventTypes = [
                'asysAngebotDefaults'
            ];

        function mapping(name, mapping) {
            if (name && mapping && !mappings[name]) {
                mappings[name] = mapping;
            }

            return that;
        }

        function setStoreName(name) {
            storeName = name;
        }

        that.mapping = mapping;
        that.setStoreName = setStoreName;

        $get.$inject = [
            '$log',
            '$rootScope',
            '$injector',
            '$location',
            '$window',
            '$document',
            '$q',
            '$http',
            'lodash',
            'moment',
            'modernizr',
            'AppConfig',
            'FormatUtilsService'
        ];

        that.$get = $get;

        function $get($log, $rootScope, $injector, $location, $window, $document, $q, $http, _, moment, modernizr, AppConfig, FormatUtilsService) {
            var integration = {},
                integrationParams = {},
                $sessionStorage,
                integrationMessages = {},
                keepAliveInterval = AppConfig.INTEGRATION.keepAliveInterval,
                heightValues = [],

                d = $window.document;

            if (_.isNaN(keepAliveInterval) || !_.isNumber(keepAliveInterval)) {
                keepAliveInterval = 5;
            }

            $sessionStorage = $injector.has('$sessionStorage') && $injector.get('$sessionStorage') || {};

            integration.initIntegrationParams = initIntegrationParams;
            integration.setIntegrationParams = setIntegrationParams;
            integration.setMappings = setMappings;
            integration.getMappings = getMappings;
            integration.removeIntegrationParams = removeIntegrationParams;
            integration.getIntegrationParams = getIntegrationParams;
            integration.setIntegrationMessages = setIntegrationMessages;
            integration.getIntegrationMessages = getIntegrationMessages;
            integration.getCredentials = getCredentials;
            integration.getExternalSid = getExternalSid;
            integration.checkSize = checkSize;
            integration.throttledCheckSize = _.throttle(checkSize, 100);
            integration.keepAlive = keepAlive;
            integration.checkPermission = checkPermission;
            integration.createAnonymSession = createAnonymSession;
            integration.checkPermissions = checkPermissions;
            integration.hasPermission = hasPermission;
            integration.getActualHeight = getActualHeight;
            integration.addHeightValue = addHeightValue;
            integration.removeHeightValue = removeHeightValue;
            integration.clearMaxHeight = clearMaxHeight;
            integration.getMaxHeight = getMaxHeight;
            integration.sendMessage = sendMessage;
            integration.handleOnMessage = handleOnMessage;
            function initIntegrationParams() {
                var searchParams = _.cloneDeep($location.search()) || {},
                    searchParamsLowercase = _.mapKeys(searchParams, function (v, k) {
                        return _.toLower(k);
                    }),
                    savedIntegrationParams,
                    bestandteileKeys = _.filter(_.split(_.trim(searchParams.ab), /\s*,\s*/)),
                    bestandteileAktiv = {};

                _.each(bestandteileKeys, function (key) {
                    if (key) {
                        bestandteileAktiv[key + '.aktiv'] = {
                            value: true
                        };
                    }
                });

                integrationParams = {
                    username: searchParams.tk ? AppConfig.API.tokenLoginPrefix + searchParams.tk : undefined,
                    password: searchParams.tp,
                    angnummer: searchParams.an,
                    angtoken: searchParams.at,
                    angmodus: searchParams.am,
                    tarifauskunftsdatum: searchParams.stichtagtarif || searchParams.dat || searchParams.ad, // NOTE(kienzle): Der "ad"-Parameter is deprecated
                    angbestandteileAktiv: bestandteileAktiv,
                    vertragsnummer: searchParams.ver,
                    vertragsKennzeichen: searchParams.verknz,
                    nachname: searchParams.nachname,
                    externalSid: searchParams.sid,
                    isTokenLogin: !!searchParams.tk,
                    paymentState: searchParams.ps,
                    stichtagTarif: searchParams.stichtagtarif,
                    aufrufer: _.toLower(searchParams.aufrufer),
                    appModus: searchParams.appModus === 'true' ? true : false,
                    referer: $document.referrer,
                    externalPermissions: [],
                    abTesting: searchParams.abt,
                    closeUrl: null
                };

                if (integrationParams.abTesting) {
                    $window.abTesting = integrationParams.abTesting;
                }

                if (modernizr.sessionstorage) {
                    integrationParams.loginDialog = !integrationParams.isTokenLogin && $window.sessionStorage.getItem('loginDialog') === 'true' ? true : false;
                    $window.sessionStorage.removeItem('loginDialog');
                }

                if (integrationParams.tarifauskunftsdatum && moment(integrationParams.tarifauskunftsdatum).isValid()) {
                    integrationParams.tarifauskunftsdatum = moment(integrationParams.tarifauskunftsdatum).format(AppConfig.API.dateFormat);
                } else {
                    integrationParams.tarifauskunftsdatum = null;
                }

                setMappings(searchParamsLowercase);
                savedIntegrationParams = getIntegrationParams(true);
                delete savedIntegrationParams.username;
                delete savedIntegrationParams.password;
                delete savedIntegrationParams.isTokenLogin;

                if (savedIntegrationParams.vertragsnummer !== integrationParams.vertragsnummer) {
                    delete savedIntegrationParams.vertragsnummer;
                    delete savedIntegrationParams.vertragsKennzeichen;
                    delete savedIntegrationParams.nachname;
                }

                if (savedIntegrationParams.reload) {
                    savedIntegrationParams.reload = false;
                } else {
                    savedIntegrationParams = {
                        hidePksLogin: savedIntegrationParams.hidePksLogin,
                        reload: false
                    };
                }

                return setIntegrationParams(_.merge({}, savedIntegrationParams, integrationParams), !!AppConfig.APP.reloadIntegrationParamsOnStart);
            }

            function setMappings(params) {
                var mapperObj = {},
                    paramsValue;

                if (mappings) {
                    _.map(mappings, function (mapping, key) {
                        paramsValue = params[_.toLower(key)];
                        if (!_.isNil(paramsValue) && paramsValue !== '') {
                            if (mapping.valueSetterPath && !mapping.valueSetter) {
                                _.forEach(mapping.valueSetterPath, function (setterPath) {
                                    _.set(mapping.value, setterPath, paramsValue);
                                });
                            } else if (angular.isFunction(mapping.valueSetter)) {
                                if (mapping.valueSetterPath) {
                                    _.set(mapping.value, mapping.valueSetterPath, mapping.valueSetter(mapping.value, paramsValue));
                                } else {
                                    mapping.value = mapping.valueSetter(mapping.value, paramsValue);
                                }
                            } else {
                                mapping.value = paramsValue;
                            }

                            if (angular.isFunction(mapping.path)) {
                                mapperObj[mapping.path()] = {
                                    value: mapping.value
                                };
                            } else {
                                mapperObj[mapping.path] = {
                                    value: mapping.value
                                };
                            }

                            if (mapping.type) {
                                mapperObj[mapping.path].type = mapping.type;
                            }

                            if (mapping.findProp) {
                                mapperObj[mapping.path].findProp = mapping.findProp;
                            }
                        }

                        if (!_.isEmpty(mapperObj)) {
                            integrationParams.mappings = mapperObj;
                        }
                    });
                }

                return getMappings();
            }

            function getMappings() {
                return integrationParams.mappings || {};
            }
            function setIntegrationParams(params, restore) {
                var parameter,
                    obj = {};

                restore = _.isNil(restore) ? true : restore;
                parameter = _.merge({}, restore ? getIntegrationParams() : {}, params);

                if (storeName) {
                    if ($sessionStorage.integrationParams) {
                        $sessionStorage.integrationParams[storeName] = parameter;
                    } else {
                        obj[storeName] = parameter;
                        $sessionStorage.integrationParams = obj;
                    }
                } else {
                    $sessionStorage.integrationParams = parameter;
                }

                integrationParams = parameter;

                return parameter;
            }
            function removeIntegrationParams() {
                if (storeName) {
                    delete $sessionStorage.integrationParams[storeName];
                } else {
                    delete $sessionStorage.integrationParams;
                }
            }
            function getIntegrationParams(onlyStored) {
                return (storeName && $sessionStorage.integrationParams ? $sessionStorage.integrationParams[storeName] : $sessionStorage.integrationParams) || (onlyStored ? {} : integrationParams) || {};
            }
            function setIntegrationMessages(message) {
                if (!message || !message.type) {
                    return integrationMessages;
                }

                integrationMessages[message.type] = message;

                return integrationMessages || {};
            }
            function getIntegrationMessages() {
                return integrationMessages;
            }
            function getCredentials() {
                var integrationParams = getIntegrationParams();
                return {
                    username: integrationParams.username,
                    password: integrationParams.password
                };
            }
            function getExternalSid() {
                return getIntegrationParams().externalSid;
            }
            function checkSize() {
                var sizeCheckFn = AppConfig.INTEGRATION.checkSizeFunction;
                if ($window.self !== $window.top && $window.parent) {
                    try {
                        if (angular.isFunction($window.parent[sizeCheckFn])) {
                            $window.parent[sizeCheckFn](getMaxHeight());
                        }
                    } catch (error) {
                    }
                }
            }
            function keepAlive() {
                return $q(function (resolve, reject) {
                    var externalSid = getExternalSid(),
                        serviceUrl;

                    if (lastKeepAlive && lastKeepAlive.isAfter(moment().subtract(keepAliveInterval, 'minutes'))) {
                        return resolve('LAST_KEEP_ALIVE_CHECK');
                    }

                    if (!externalSid) {
                        return reject('KEINE_SID');
                    }

                    if (AppConfig.INTEGRATION.services.keepAlive) {
                        serviceUrl = FormatUtilsService.replace(AppConfig.INTEGRATION.services.keepAlive, externalSid, moment().unix());
                    } else {
                        return resolve('KEINE_INTEGRATION');
                    }

                    lastKeepAlive = moment();

                    $http.get(serviceUrl, {
                        unexpectedErrorsIgnore: true
                    }).then(function (response) {
                        var result = _.get(response.data, 'result') || {};

                        if (result.active === 'NEIN') {
                            return reject({
                                active: false,
                                error: result.message
                            });
                        }

                        resolve(result);
                    }).catch(function (error) {
                        reject({
                            error: error
                        });
                    });
                });
            }
            function checkPermission(permission) {
                var externalSid = getExternalSid(),
                    serviceUrl = AppConfig.INTEGRATION.services.checkPermission;

                if (!serviceUrl) {
                    return $q.reject('KEIN_SERVICE_DEFINIERT');
                }

                if (!externalSid || !permission) {
                    return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
                }

                serviceUrl = FormatUtilsService.replace(serviceUrl, externalSid, permission, moment().unix());

                return $http.get(serviceUrl, {
                    unexpectedErrorsIgnore: true
                }).then(function (response) {
                    var result = _.get(response.data, 'result') || {};

                    if (result.active === 'NEIN') {
                        return $q.reject({
                            active: false,
                            error: result.message
                        });
                    }

                    return result;
                });
            }
            function createAnonymSession() {
                return $http.get(AppConfig.INTEGRATION.services.createAnonymSession, {
                    httpErrorsIgnore: true,
                    unexpectedErrorsIgnore: true
                }).then(function (response) {
                    response = response || {};

                    var data = response.data || {};

                    if (data.error) {
                        return $q.reject(data.error);
                    }

                    return data.sid;
                });
            }
            function checkPermissions() {
                var permissionsToCheck = AppConfig.INTEGRATION.permissionsToCheck,
                    externalPermissions;

                if (_.isArray(permissionsToCheck) && _.size(permissionsToCheck) > 0) {
                    _.forEach(permissionsToCheck, function (permission) {
                        externalPermissions = getIntegrationParams().externalPermissions || [];

                        if (!_.find(externalPermissions, ['id', permission])) {
                            checkPermission(permission).then(function (data) {
                                externalPermissions.push({
                                    id: permission,
                                    permission: true
                                });
                            }).catch(function (error) {
                                error = error || {};

                                if (error === 'KEIN_SERVICE_DEFINIERT' || error.active === false) {
                                    externalPermissions.push({
                                        id: permission,
                                        permission: false
                                    });
                                }
                            }).finally(function () {
                                setIntegrationParams({ externalPermissions: externalPermissions });
                            });
                        }
                    });
                }
            }
            function hasPermission(permission, externalPermissions) {
                var externalPermission = _.find((externalPermissions || getIntegrationParams().externalPermissions), ['id', permission]);

                if (_.isNil(externalPermission)) {
                    return false;
                }

                return _.get(externalPermission, 'permission');
            }
            function getActualHeight() {
                return $window.Math.max(
                    d.body.scrollHeight, d.documentElement.scrollHeight,
                    d.body.offsetHeight, d.documentElement.offsetHeight,
                    d.body.clientHeight, d.documentElement.clientHeight
                );
            }
            function addHeightValue(heightValueInPx, key) {
                heightValues.push({
                    key: key,
                    height: heightValueInPx
                });
            }
            function removeHeightValue(heightValueInPx, key) {
                var idx = heightValues.indexOf({
                    key: key,
                    height: heightValueInPx
                });

                if (idx !== -1) {
                    heightValues.splice(idx, 1);
                }
            }
            function clearMaxHeight(key) {
                if (!key) {
                    heightValues = [];
                } else {
                    _.remove(heightValues, function (val) {
                        return val.key === key;
                    });
                }
            }
            function getMaxHeight() {
                var val = $window.Math.max.apply(null, _.map(heightValues, 'height')),
                    isFinite = $window.Number.isFinite || $window.isFinite;

                if (angular.isFunction(isFinite)) {
                    return isFinite(val) ? val : null;
                } else {
                    return val;
                }
            }
            function sendMessage(message, windowRef) {
                if (!message) {
                    return;
                }

                windowRef = windowRef || $window.opener || $window.parent;
                if (windowRef === $window.self || !windowRef || !angular.isFunction(windowRef.postMessage)) {
                    return;
                }

                if (windowRef.postMessage.length < 1) {
                    windowRef.postMessage(JSON.stringify(message));
                } else {
                    windowRef.postMessage(JSON.stringify(message), AppConfig.INTEGRATION.postMessageOrigin);
                }
            }
            function handleOnMessage(event, message) {
                if (
                    (
                        !_.includes(AppConfig.INTEGRATION.messageOrigins, event.origin) &&
                        !_.includes(AppConfig.INTEGRATION.messageOrigins, '*')
                    ) ||
                    !message ||
                    !_.includes(allowedMessageEventTypes, message.type)
                ) {
                    return;
                }

                setIntegrationMessages(message);
                $log.log('handleOnMessage', message.type, message, event.origin);
                $rootScope.$emit('iplusjs:' + message.type, message);
            }

            return integration;
        }

    }
})();
